module.exports = __webpack_public_path__ + "img/07.2793fd38.gif";